import router from '@/router'
import { getAuthInfo } from '@/api/login'
import { getUrlParam } from '@/utils/utils'
import axios from '@/utils/axios'
const ROLES = ['Admin', 'AdminTeacher', 'Student']

let info = null
router.beforeEach(async (to, from, next) => {
  // 拦截ticket授权
  var obj = getUrlParam(window.location.href)
  if (obj.ticket) {
    localStorage.setItem('Authorization', obj.ticket)
  }
  if (!info) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('Authorization')
    info = await getAuthInfo()
    localStorage.setItem('userInfo', JSON.stringify(info.data))
  }
  if (info && info.data) {
    // 根据用户角色判断跳转逻辑
    const roles = to.meta?.roles
    if (roles && !roles.includes(ROLES[info.data.roleLength])) {
      next('/myMeeting')
    } else {
      next()
    }
  } else {
    next()
  }
})
